let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("49QGJ")).then(() => parcelRequire('l2W1h'));